export interface IPuzzleAleoRecord {
  _id: string;
  height: number;
  timestamp: string;
  ciphertext: string;
  programId: string;
  functionId: string;
  name: string;
  network: string;
  transitionId: string;
  transactionId: string;
  index: number;
  owner: string;
  serialNumber: string;
  status: keyof typeof RecordStatus;
  plaintext: string;
  microcredits: number;
  data: {
    [key: string]: string;
  };
}

export enum RecordStatus {
  Unspent = 'Unspent',
  Spent = 'Spent',
}
